import {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useReadRmaDetail from "../hooks/useReadRmaDetail";
import EmptyTableRow from "../../../common/EmptyTableRow";
import moment from "moment";
import useExportExcelDetail from "../hooks/useExportExcelDetail";
import {useUser} from "../../../../util/userContext/UserContext";
import {useModal} from "../../../../hooks";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export const RmaDetail = () => {
    const navigate = useNavigate();
    const [tab, setTab] = useState("tab-1");
    const {id} = useParams();
    const {data} = useReadRmaDetail(id as string);
    const {handleModal} = useModal();
    const {user} = useUser();

    const {mutate: exportMutate} = useExportExcelDetail();


    return (
        <>
            <div className="content_wrap">
                <div className="content_top">
                    <h3 className="filter_heading">RMA 상세보기</h3>
                    <div className=""></div>
                    <div className="content_toolbar">
                        <button
                            className="btn btn-outline-primary w-100px h-38px"
                            onClick={() => navigate(-1)}
                        >
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/icon_hamburger_btn.png"
                                }
                                alt=""
                            />
                            목록
                        </button>
                        <AuthorityChecker authorityNames={['rmaWriteYn']}>
                            <button
                                className="btn btn-secondary w-100px h-38px"
                                onClick={() =>
                                    navigate(`${process.env.PUBLIC_URL}/support/rma/update/${id}`, {
                                        replace: true,
                                    })
                                }
                            >
                                수정
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                <h5 className="subheading">RMA 기본정보</h5>

                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        <th style={{width: "16.66%"}}>RMA 번호</th>
                        <td style={{width: "16.66%"}}>{data?.rmaDetail.code}</td>
                        <th style={{width: "16.66%"}}>RMA 일자</th>
                        <td style={{width: "16.66%"}}>
                            {data?.rmaDetail &&
                                moment(data?.rmaDetail.rmaAt).format("YYYY.MM.DD")}
                        </td>
                        <th style={{width: "16.66%"}}>규격</th>
                        <td>{data?.rmaDetail.newTxtStndItem}</td>
                    </tr>
                    <tr>
                        <th>COA</th>
                        <td>{data?.rmaDetail.coa}</td>
                        <th>수량</th>
                        <td>{data?.rmaDetail.quantity ?? 0}EA</td>
                        <th>상태</th>
                        <td>{data?.rmaDetail.questionState}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button
                        type="button"
                        className={
                            tab == "tab-1" ? "btn btn-light active" : "btn btn-light"
                        }
                        onClick={() => setTab("tab-1")}
                    >
                        RMA 정보
                    </button>
                    <button
                        type="button"
                        className={
                            tab == "tab-2" ? "btn btn-light active" : "btn btn-light"
                        }
                        onClick={() => setTab("tab-2")}
                    >
                        고객정보
                    </button>
                </div>
                <div className="mybtns_group_toolbar">
                    <button
                        type="button"
                        className="btn btn-dark w-150px px-0"
                        onClick={() => {
                            exportMutate({rmaId: Number(id)});
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"}
                            alt=""
                        />
                        엑셀 내보내기
                    </button>
                </div>
            </div>

            {tab == "tab-1" && (
                <>
                    <div className="content_wrap">
                        <div className="table_scroll m-0">
                            <table className="table table-bordered my_table table_detail">
                                <tbody>
                                <tr>
                                    <th style={{width: "16.66%"}}>Distributor Name</th>
                                    <td colSpan={3}>{data?.rmaDetail.distributorName}</td>
                                </tr>
                                <tr>
                                    <th>MS Sold to Number</th>
                                    <td>{data?.rmaDetail.msSoldToNumber}</td>
                                    <th style={{width: "16.66%"}}>Agreement Number</th>
                                    <td>{data?.rmaDetail.agreementNumber}</td>
                                </tr>
                                <tr>
                                    <th>Contact Information</th>
                                    <td colSpan={3}>{data?.rmaDetail.contactInformation}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="content_wrap">
                        <div className="table_scroll m-0">
                            <table className="table table-bordered my_table">
                                <thead>
                                <tr>
                                    <th style={{width: "4.4%"}}>NO</th>
                                    <th style={{width: "10.56%"}}>End Item Number</th>
                                    <th style={{width: "10.56%"}}>COA Base Stock</th>
                                    <th style={{width: "13.64%"}}>Beginning COA Number *</th>
                                    <th style={{width: "11%"}}>Ending COA Number</th>
                                    <th style={{width: "7.5%"}}>Quantity</th>
                                    <th style={{width: "10.56%"}}>Original PO</th>
                                    <th style={{width: "10.56%"}}>Return Reason</th>
                                    <th style={{width: "10.56%"}}>Comments</th>
                                    <th>Received Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data?.rmaDetail?.rmaDetailList?.length === 0 ? (
                                    <EmptyTableRow/>
                                ) : (
                                    data?.rmaDetail?.rmaDetailList?.map((item, index) => (
                                        <tr>
                                            <td className="text-center">{index + 1}</td>
                                            <td className="text-center">{item.endItemNumber}</td>
                                            <td className="text-center">{item.coaBaseStock}</td>
                                            <td className="text-center">
                                                {item.beginningCoaNumber}
                                            </td>
                                            <td className="text-center">{item.endingCoaNumber}</td>
                                            <td className="text-center">{item.quantity}</td>
                                            <td className="text-center">{item.originalPo}</td>
                                            <td className="text-center">{item.returnReason}</td>
                                            <td className="text-center">{item.comments}</td>
                                            <td className="text-center">{item.receivedDate}</td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}

            {tab == "tab-2" && (
                <div className="content_wrap">
                    <div className="table_scroll m-0">
                        <table className="table table-bordered my_table table_detail">
                            <tbody>
                            <tr>
                                <th style={{width: "16.7%"}}>거래처</th>
                                <td style={{width: "33.33%"}}>
                                    {data?.rmaDetail.customerCompanyName}
                                </td>
                                <th style={{width: "8.3%"}} rowSpan={3}>
                                    연락처
                                </th>
                                <th style={{width: "8.3%"}}>성함</th>
                                <td>{data?.rmaDetail.customerAlias}</td>
                            </tr>
                            <tr>
                                <th>RMA 일자</th>
                                <td>
                                    {data?.rmaDetail &&
                                        moment(data?.rmaDetail.rmaAt).format("YYYY.MM.DD")}
                                </td>
                                <th>전화번호</th>
                                <td>{data?.rmaDetail.customerPhoneNo}</td>
                            </tr>
                            <tr>
                                <th>벤더</th>
                                <td>{data?.rmaDetail.vendor}</td>
                                <th>이메일</th>
                                <td>{data?.rmaDetail.customerCoEmail}</td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td>{data?.rmaDetail.category}</td>
                                <th colSpan={2}>
                                    담당자
                                </th>
                                <td>{data?.rmaDetail.handlerName}</td>
                            </tr>
                            <tr>
                                <th>품목명</th>
                                <td>{data?.rmaDetail.newTxtNmItem}</td>
                                <th colSpan={2}>요청자</th>
                                <td>{data?.rmaDetail.requesterName ?? 0}</td>
                            </tr>
                            <tr>
                                <th>규격</th>
                                <td>{data?.rmaDetail.newTxtStndItem}</td>
                                <th colSpan={2}>수량</th>
                                <td>{data?.rmaDetail.quantity ?? 0}</td>
                            </tr>
                            <tr>
                                <th>COA</th>
                                <td colSpan={5}>{data?.rmaDetail.coa}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {tab == "tab-3" && (
                <div className="content_wrap">
                    <div className="table_scroll m-0">
                        <table className="table table-bordered my_table table_detail">
                            <tbody>
                            <tr>
                                <th style={{width: "16.66%"}}>Distributor Name</th>
                                <td colSpan={3}>{data?.rmaDetail.distributorName}</td>
                            </tr>
                            <tr>
                                <th>MS Sold to Number</th>
                                <td>{data?.rmaDetail.msSoldToNumber}</td>
                                <th style={{width: "16.66%"}}>Agreement Number</th>
                                <td>{data?.rmaDetail.agreementNumber}</td>
                            </tr>
                            <tr>
                                <th>Contact Information</th>
                                <td colSpan={3}>{data?.rmaDetail.contactInformation}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
};
